(function($){
$(document).ready(function() {
    const url_panier = "/mon-compte/mon-panier";
    const nf = new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
    });
    const log_functions = true;

    // hack pour le bug Firefox sur les input qui n'affichent pas la bonne valeur
    $(".antibug-ff").each(function(){$(this)[0].reset()});

    $('.mini-panier').appendTo($('.client-header .panier'));

    let commande = JSON.parse(localStorage.getItem('commande'));
    let infosCommande = { montant: get_montant_commande(), nb_article: get_nb_article() };

    save_commande_in_session(maj_quantite_commande);

    $('.bloc-ajout-panier .ajout-panier').on('click touchend', function(e){
        e.preventDefault();
        $(this).prop("disabled", true);
        const $produit = $(this).parents('.produit, .selection-sachet, .article-librairie');
        if ($produit.hasClass('bientot')){
            alert('Produit en cours de conditionnement !');
        }
        else if ($produit.hasClass('magasin')){
            alert('Produit reservé aux clients revendeurs !');
        }
        else if ($produit.hasClass('indispo')){
            alert('Produit épuisé !');
        }
        else if ($produit.hasClass('bloque')){
            alert('Produit indisponible !');
        }
        else{
            let $icon  = $(this).find('i'),
                id     = $(this).data('ligne'),
                type   = $(this).data('type'),
                option = $(this).data('option'),
                titre  = $(this).data('titre'),
                infos  = $(this).data('infos'),
                qte    = $(this).data('defaut'),
                prix   = $(this).data('prix'),
                prix_barre   = $(this).data('prix_barre'),
                promo   = $(this).data('promo'),
                min    = $(this).data('min'),
                max    = $(this).data('max'),
                vignette_url = $(this).data('vignette_url'),
                refligne = type+'-'+id+'-'+option;

            animate_panier($icon);

            ajout_produit_commande(id, type, option, titre, infos, qte, prix, min, max, vignette_url,prix_barre,promo);

            $(".bloc-ajout-panier-"+refligne).addClass('au-panier').find('.quantite').val(qte);
        }
    });

    $('body').on('click', '.bloc-ajout-panier .qchange', function() {
        let id       = $(this).data('ligne'),
            $thisQte = $('.quantite' + id),
            ajout    = 1 * $(this).data('ajout'),
            qte      = 1 * $thisQte.val(),
            new_qte = verif_qte($thisQte, qte + ajout);

        delay(function(){
            $thisQte.change();
        }, 200 );
    });

    $('body').on('change', '.quantite', function(){
        let qte      = verif_qte($(this), $(this).val());
        //let qte      = $(this).val();
        let from     = ($(this).hasClass('quantite-panier')) ? "mini-panier" : ($(this).hasClass('quantite-fiche')) ? "fiche" : "liste";
        let refligne = $(this).data('type') + '-' + $(this).data('id') + '-' + $(this).data('option');
        let prix     = $(this).data('prix');
        console.log("refligne :"+refligne);
        maj_commande(refligne, qte, prix, from);
    });

    $('body').on('click touchend', '.supprimer-mini-panier', function(e){
        e.preventDefault();
        e.stopPropagation();
        let refligne = $(this).data('ligne');
        maj_commande(refligne, 0, 0, "mini-panier");
    });

    $('body').on('click touchend', '.vider-panier', function(e){
        $.popin.confirm({
            message: 'Êtes-vous sûr de vouloir vider votre panier ?',
            title: 'Suppression des articles mis au panier',
            button: 'Vider',
            buttonCl: 'Annuler',
            callback: vider_commande
        });
    });


    function vider_commande() {
        if (log_functions) {
            console.log('vider_commande');
        }

        localStorage.removeItem('commande');
        commande = {};
        infosCommande = { montant: 0, nb_article: 0 };
        save_commande_in_session(vider_panier);
        $.popin.close();
    };

    function vider_panier() {
        if (log_functions) {
            console.log('vider_panier');
        }

        update_infos_panier();
        update_infos_liste();
        $(".bloc-ajout-panier").removeClass('au-panier');
        localStorage.removeItem('infosCommande');
        scrollTo(0,0);
    }


    function ajout_produit_commande(id, type, option, titre, infos, qte, prix, min, max, vignette_url, prix_barre, promo) {
        if (log_functions) {
            console.log('ajout_produit_commande', id, type, option, titre, infos, qte, prix, min, max, vignette_url);
        }

        let vignette = '';
        if(promo != undefined && promo != '')
          vignette = '<div class="pill-promo">'+promo+'</div>';

        let prix_affiche = prix_francais(prix);
        if(promo != undefined && promo != '')
          prix_affiche = '<div class="prix-barre">'+prix_francais(prix_barre)+'</div><div class="prix-promo">'+prix_francais(prix)+'</div>';

        let refligne = type+'-'+id+'-'+option;

        let tpl_infos_panier = `
            <div class="infos-panier">
                <div class="prix-total"></div>
                <a href="#" class="vider-panier"><i class="icon-delete"></i><span class="sr-only">Vider mon panier</span></a>
                <a class="btn-valider-panier" href="${url_panier}">Accéder au panier</a>
            </div>
        `;

        let tpl_ligne = `
            <li>
                <div class="titre">${titre}</div>
                <div class="illu">${vignette}<picture><img src="${vignette_url}" alt=""></picture></div>
                <div class="infos">
                    ${infos}<div class="quantite-mini-panier">
                        <div class="prix-unitaire">${prix_affiche}</div>
                        <div class="bloc-ajout-panier">
                            <button data-ligne="${refligne}" class="qchange moins" type="button" data-ajout="-1">
                                -
                            </button>
                            <input class="quantite quantite-panier quantite${refligne}" data-id="${id}" data-ligne="${refligne}" type="text" inputmode="decimal" min="${min}" max="${max}" value="${qte}" data-type="${type}" data-option="${option}" data-prix="${prix}"">
                            <button data-ligne="${refligne}" class="qchange plus" type="button" data-ajout="1">
                                +
                            </button>
                        </div>
                        <button type="button" data-ligne="${refligne}" class="supprimer-mini-panier"><span class="sr-only">supprimer</span><i class="icon-x"></i></button>
                    </div>
                </div>
            </li>
        `;

        if ($('.mini-panier-content li').length == 0){
            $('.mini-panier-content').html(tpl_infos_panier + '<ul></ul>');
        }
        $('.mini-panier-content ul').prepend(tpl_ligne);

        maj_commande(refligne, qte, prix, "new");
    }

    function maj_commande(refligne, qte, prix, from) {
        if (log_functions) {
            console.log('maj_commande', refligne, qte, prix, from);
        }

        let isPanierListe = $('.panier-liste').length > 0;

        if (from == "new") {
            let ligne_pdt = {};
            ligne_pdt[refligne] = { quantite: qte, prix_unitaire: prix };
            commande = Object.assign(ligne_pdt, commande);
        } else {
            commande[refligne].quantite = qte;
            cible = (from == "mini-panier") ? $(".bloc-ajout-panier-"+refligne+" .quantite") : $('.quantite'+refligne);
            cible.val(qte);
        }
        if (qte == 0) {
            delete(commande[refligne]);
            $('.quantite' + refligne).parents('li').first().remove();
            $(".bloc-ajout-panier-" + refligne).removeClass('au-panier');
            if (isPanierListe) {
                $('#ligne' + refligne).remove();
            }
        }

        infosCommande['montant'] = get_montant_commande();
        infosCommande['nb_article'] = get_nb_article();

        update_local_storage();
        update_infos_panier();

        update_infos_liste(refligne);

        save_commande_in_session(function(){
            if (from == "new") {
                $(".bloc-ajout-panier-" + refligne + " .ajout-panier").prop("disabled", false);
            }
            if ($('#etape3').length)
              reload_tabs_commande(3);
        });
    }

    function maj_quantite_commande(data) {
        if (log_functions) {
            console.log('maj_quantite_commande', data);
        }

        if (data == "vider") {
            vider_commande();
        } else {
            let popin = false;
            let lignes_to_update = JSON.parse(data);
            if (lignes_to_update != null && Object.keys(lignes_to_update).length > 0) {
                for (key in lignes_to_update) {
                    if (lignes_to_update[key]['nouvelle_quantite'] != undefined) {
                        popin = true;
                        commande[key].quantite = lignes_to_update[key]['nouvelle_quantite'];
                    }
                    if (lignes_to_update[key]['nouveau_prix_unitaire'] != undefined) {
                        commande[key].prix_unitaire = lignes_to_update[key]['nouveau_prix_unitaire'];
                    }
                }
                infosCommande = { montant: get_montant_commande(), nb_article: get_nb_article() };
                update_local_storage();
                update_infos_panier();
                if (popin) {
                    $.popin.alert({
                        message: '<p>Certains articles mis au panier sont épuisés ou n\'ont plus la quantité que vous souhaitiez de disponible.</p><p>Les quantités ont été mises à jours, vérifiez <a href="'+url_panier+'">votre panier</a></p>',
                        title: 'Mise à jour de votre panier'
                    });
                }
            }
            if (infosCommande['nb_article'] > 0 && $('.mini-panier li').length == 0) {
                $.ajax({
                    url: '/xhr-actions/get_minipanier',
                    success : function(data) {
                        $('.mini-panier').html(data);
                        reload_tabs_commande(1);
                        update_compteur_panier(infosCommande['nb_article']);
                    }
                });
            }
        }
    }

    function reload_tabs_commande(n) {
        if (log_functions) {
            console.log('reload_tabs_commande', n);
        }

        if (n == 1 && $('#etape1').length) {
            $.ajax({
                url: '/xhr-actions/get_tab_commande?etape=1',
                success : function(data) {
                    $('#etape1 .tab-commande').html(data);
                }
            });
        }
        if (n == 3 && $('#etape3').length) {
            if (infosCommande['nb_article'] == 0) {
                $("#etape3").html('<h2 class="panel-title">Récapitulatif et paiement</h2><p>Votre panier est vide</p>');
            } else {
                $.ajax({
                    url: '/xhr-actions/get_tab_commande?etape=3',
                    success : function(data) {
                        $('#etape3 .tab-commande').html(data);
                    }
                });
            }
        }
    }


    function save_commande_in_session(cb){
        if (log_functions) {
          console.log('save_commande_in_session', cb);
        }

        let params = {
            commande: commande
        }
        $.ajax({
            url: '/xhr-actions/save_commande_in_session',
            method: "POST",
            data: params,
            success : cb
        });
    }

    function update_local_storage() {
        if (log_functions) {
          console.log('update_local_storage');
        }

        localStorage.setItem('commande', JSON.stringify(commande));
        localStorage.setItem('infosCommande', JSON.stringify(infosCommande));
    }

    function verif_qte(elt, qte){
        if (log_functions) {
            console.log('verif_qte', elt, qte);
        }

        let qmax    = 1 * elt.attr('max'),
            new_qte = (qte < 0 ) ? 0 : (qte > qmax) ? qmax : qte;
        if (qte > qmax) {
            alert('Quantité maximum atteinte pour cet article (' + qmax + ')');
        }
        elt.val(new_qte);
        return new_qte;
    }

    function get_nb_article() {
        if (log_functions) {
            console.log('get_nb_article');
        }

        let nb_article = 0,
            key = "";
        for (key in commande) {
            nb_article += (1 * commande[key].quantite);
        }
        return nb_article;
    }

    function get_montant_commande() {
        if (log_functions) {
            console.log('get_montant_commande');
        }

        let montant_commande = 0,
            key = "";
        for (key in commande) {
            montant_commande += (1 * commande[key].quantite) * (1 * commande[key].prix_unitaire);
        }
        return Math.round(100*montant_commande)/100;
    }

    function update_compteur_panier(cpt){
        if (log_functions) {
            console.log('update_compteur_panier', cpt);
        }

        const $icone = $("#compteur-panier").siblings("i");
        if (cpt == 0) {
            $("#compteur-panier").addClass('hidden').html("");
            $icone.removeClass('plein');
        }
        else{
            $("#compteur-panier").removeClass('hidden').html(cpt)
            $icone.addClass('plein');
        }
    }

    function update_infos_panier(){
        if (log_functions) {
            console.log('update_infos_panier');
        }

        let nb_article = infosCommande['nb_article'];
        if (nb_article == 0 || nb_article == undefined) {
            $('.mini-panier-content').html('<p class="notice"><em>Aucun article au panier</em></p>');
            $('#montant_hors_port').val(0);
        } else {
            montant = infosCommande['montant'];
            let s = (nb_article > 1) ? 's' : '';
            $('#montant_hors_port').val(montant);
            $('.infos-panier .prix-total').html(nb_article + " article" + s + " : " + nf.format(montant) );
        }
        update_compteur_panier(nb_article);
    }

    function update_infos_liste(refligne){
        if (log_functions) {
            console.log('update_infos_liste', refligne);
        }

        let isPanierListe = $('.panier-liste').length > 0;
        if (isPanierListe) {
            let nb_article = infosCommande['nb_article'],
                montant = infosCommande['montant'],
                s = (nb_article > 1) ? 's' : '';
            if (nb_article == 0) {
                $('.tab-commande').html('<p>Votre panier est vide</p>');
            } else {
                if (commande[refligne] != undefined) {
                    let montantligne = Math.round(100 * commande[refligne].quantite * commande[refligne].prix_unitaire)/100;
                    $('#ligne'+refligne+" .prix-total").html(nf.format(montantligne));
                }
                $('.infos-sous-total .nb-articles').html(nb_article + " article" + s );
                $('.infos-sous-total .montant').html(nf.format(montant));
            }
        } else {
            reload_tabs_commande(1);
        }
    }

}); // document.ready
})(jQuery);

let delay = (function(){
    let timer = 0;
    return function(callback, ms){
        clearTimeout (timer);
        timer = setTimeout(callback, ms);
    };
})();

function animate_panier(elt){
    let $btnMiniPanier = $('.client-header .panier i');
    let $animPanier = elt.clone().addClass('animPanier');
    let start = elt.offset();
    let end = $btnMiniPanier.offset();
    end.width = $btnMiniPanier.width();
    end.height = $btnMiniPanier.height();
    $animPanier.appendTo($('body'));

    let isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (!isSafari) {
        let upAndFade = [
            { top: start.top+"px", left: start.left+"px" },
            { top: end.top+"px", left: end.left+"px", width: end.width+"px", height: end.height+"px", opacity: .8 },
            { opacity: 0 },
        ];
        $animPanier[0].animate(upAndFade, {
            duration: 2500,
            easing: 'ease-out',
        }).onfinish = function(){
            $animPanier.remove();
        };
    }
    else{
        let styles={top: start.top, left: start.left}
        $animPanier.css(styles);
        $animPanier.animate({
            top: end.top,
            left: end.left,
            width: end.width,
            height: end.height,
            opacity: 0.3
        }, 1000, function() {
            $animPanier.remove();
        });
    }
}
